import '../created/styles.scss';
import l from '../../../../lang';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';
import { Button } from '../../../common/button';
import { Routes } from '../../../../config/routes';
import { useHistory } from 'react-router-dom';
import CreatedRecurringPaymentLink from '../created/reccuring';
import { canCreatePaymentLinks } from '../../../../store/payment-link/roles';
import { useSelector } from 'react-redux';

const RecurringPaymentLinkPage = () => {
  const history = useHistory();
  const { auth } = useSelector(state => state);
  const canCreate = canCreatePaymentLinks(auth?.roles);

  const onCreateRecurringPaymentLinkHandler = () => {
    history.push(Routes.CREATE_RECURRING_PAYMENT_LINK);
  };

  return (
    <div className="created_payment_links">
      <TopDashboardSection
        title={l('menu.subItem.RECURRING_PAYMENT_LINK')}
        subtitle={l('recurringPaymentLink.page.subheadline')}
      />
      <Card>
        <CardDescription>{l('recurringPaymentLink.page.cardDescription')}</CardDescription>
        <div className="created_payment_links__create_btn">
          <Button fullWidth disabled={!canCreate} onClick={onCreateRecurringPaymentLinkHandler}>
            {l('createdPaymentLink.redirectBtn')}
          </Button>
        </div>
        <div className="created_payment_links__content">
          <CreatedRecurringPaymentLink />
        </div>
      </Card>
    </div>
  );
};

export default RecurringPaymentLinkPage;
